import { createContext, useContext } from "react";

export const MeetingContext = createContext(null);

export const useMeeting = () => useContext(MeetingContext);
